module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "address flex-between",
    on: {
      "click": function($event) {
        _vm.addressPickerShow = true
      }
    }
  }, [_c('div', {
    staticClass: "address-left flex-start"
  }, [_c('img', {
    staticClass: "address-img",
    attrs: {
      "src": require("../../../assets/newImg/icon-address-location.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-detail"
  }, [_c('div', {
    staticClass: "address-pro"
  }, [_vm._v(_vm._s(_vm.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "address-phone"
  }, [_vm._v(_vm._s(_vm.address.name) + " " + _vm._s(_vm.address.phone))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "address-back"
  })]), _vm._v(" "), _vm._l((_vm.order_list), function(order, index) {
    return _c('div', {
      staticClass: "border-top"
    }, [_c('div', {
      staticClass: "row-title"
    }, [_c('div', {
      staticClass: "title-left"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": order.business_pic_url,
        "alt": ""
      }
    }), _vm._v("\n        " + _vm._s(order.business_name) + "\n      ")])]), _vm._v(" "), _vm._l((order.goods_items), function(goods, index) {
      return _c('div', {
        staticClass: "flex-between row-between"
      }, [_c('div', {
        staticClass: "between-left flex-start"
      }, [_c('img', {
        staticClass: "between-left-img",
        attrs: {
          "src": goods.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-box"
      }, [_c('div', {
        staticClass: "between-left-title"
      }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "between-left-detail gray-light"
      }, [_vm._v(_vm._s(goods.sku.sku_formart))]), _vm._v(" "), _c('div', {
        staticClass: "between-left-price"
      }, [_vm._v("¥" + _vm._s(goods.price))])])]), _vm._v(" "), _c('div', {
        staticClass: "between-right"
      }, [_c('div', {
        staticClass: "between-right-num gray-light"
      }, [_c('span', [_vm._v("数量")]), _vm._v("\n          " + _vm._s(goods.count) + "\n        ")])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("商品金额")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_vm._v("¥" + _vm._s(order.goods_price))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("运费")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_vm._v("¥" + _vm._s(order.express_price))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("优惠")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_c('span', [_vm._v("¥" + _vm._s(order.discount_price))])])]), _vm._v(" "), _c('div', {
      staticClass: "row-list"
    }, [_c('div', [_vm._v("买家留言")]), _vm._v(" "), _c('div', {
      staticClass: "message-text"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "placeholder": "您还有其他什么要求..."
      },
      on: {
        "change": function($event) {
          return _vm.noteChange(order.business_id, $event)
        }
      }
    })])])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer flex-between"
  }, [_c('div', {
    staticClass: "footer-left flex-start"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("总计")]), _vm._v("\n      ¥" + _vm._s(_vm.pay_price) + "\n    ")]), _vm._v(" "), (!_vm.submitLoading) ? _c('div', {
    staticClass: "footer-right",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("去支付")]) : _c('div', {
    staticClass: "footer-right"
  }, [_vm._v("提交中...")])]), _vm._v(" "), _c('AddressPicker', {
    attrs: {
      "show": _vm.addressPickerShow
    },
    on: {
      "onChange": _vm.changeAddress,
      "onClose": _vm.closeAddress
    }
  }), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "scene": "goods",
      "show": _vm.payDialogShow,
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('CouponPicker', {
    attrs: {
      "show": _vm.couponPickerShow,
      "list": _vm.currentCouponList,
      "business_id": _vm.currentBusinessId,
      "index": _vm.currentBusinessIndex
    },
    on: {
      "onChange": _vm.changeCoupon
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-right"
  }, [_c('img', {
    staticClass: "icon-right",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd8fe74e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tuan/TuanOrderCheck.vue
// module id = 2612
// module chunks = 0